"use strict";Object.defineProperty(exports, "__esModule", {value: true}); var _class;

var _chunk3SFKQNZAcjs = require('./chunk-3SFKQNZA.cjs');


var _chunkHJFO65XKcjs = require('./chunk-HJFO65XK.cjs');


var _chunkNE5AG7IWcjs = require('./chunk-NE5AG7IW.cjs');

// src/contracts/dex/v2_2/pool/BasePoolV2_2.ts
var BasePoolV2_2 = (_class = class extends _chunkHJFO65XKcjs.BasePoolV2_1 {
  static __initStatic() {this.version = _chunkNE5AG7IWcjs.DEX_VERSION.v2_2}
  async getLpAccount(provider, params) {
    const lpAccountAddress = await this.getLpAccountAddress(provider, params);
    return _chunk3SFKQNZAcjs.LpAccountV2_2.create(lpAccountAddress);
  }
}, _class.__initStatic(), _class);



exports.BasePoolV2_2 = BasePoolV2_2;
//# sourceMappingURL=chunk-XKXSN756.cjs.map